module.exports = __webpack_public_path__ + "media/images/calendar2026-7a6811c3bb22a21b904082ce67002422.png";